import React from 'react';

const InstructionTelegram: React.FC = () => {
  return (
    <div
      className="p-4 rounded-lg shadow-lg mr-2"
      style={{
        backgroundColor: 'var(--component-bg-color)',
        color: 'var(--text-color)',
        maxWidth: '300px',
        maxHeight: '400px', // กำหนดความสูงสูงสุด
        overflowY: 'auto', // เพิ่ม scroll เมื่อเนื้อหาเกินความสูง
      }}
    >
      <h2 className="text-lg font-bold mb-4">วิธีการเชื่อมต่อ Telegram</h2>
      <ol className="list-decimal list-inside space-y-2 text-sm">
        <li>ติดตั้ง Telegram ลง Desktop และเข้าสู่ระบบให้เรียบร้อย   <a
          href="https://desktop.telegram.org"
          target="_blank"
          rel="noopener noreferrer"
          className="text-yellow-500 underline"
        >
          https://desktop.telegram.org
        </a></li>
        <img
          src="/telegramFlow/0.png" // ใส่ path ของรูปภาพที่ต้องการ
          alt="Copy Telegram Code"
          className="w-full rounded-lg shadow"
        />
        <hr />
        <li>Copy โค้ดเลข 6 หลัก และกด "ไปยัง Telegram"</li>
        <img
          src="/telegramFlow/1.png" // ใส่ path ของรูปภาพที่ต้องการ
          alt="Copy Telegram Code"
          className="w-full rounded-lg shadow"
        />
        <hr />
        <li>กด Start Bot (จำเป็นต้องมี telegram บน PC ก่อนใช้งาน) </li>
        <img
          src="/telegramFlow/2.png" // ใส่ path ของรูปภาพที่ต้องการ
          alt="Start Bot"
          className="w-full rounded-lg shadow"
        />
        <hr />
        <li>กด "Start" ด้านล่างเพื่อเริ่มทำงานบอท</li>
        <img
          src="/telegramFlow/3.png" // ใส่ path ของรูปภาพที่ต้องการ
          alt="Start Bot"
          className="w-full rounded-lg shadow"
        />
        <hr />
        <li>กด "Start" ด้านล่างซ้ายเพื่อเชื่อมต่อเว็บ</li>
        <img
          src="/telegramFlow/4.png" // ใส่ path ของรูปภาพที่ต้องการ
          alt="Start Bot"
          className="w-full rounded-lg shadow"
        />
        <hr />
        <li>นำโค้ดเลข 6 หลัก มากรอกและกด "เชื่อมต่อ Telegram"</li>
        <img
          src="/telegramFlow/5.png" // ใส่ path ของรูปภาพที่ต้องการ
          alt="Start Bot"
          className="w-full rounded-lg shadow"
        />
      </ol>
      <hr className="mt-2" />
      <p className="mt-4 text-xs text-gray-400">
        หากเคยเชื่อมต่อแล้วมันจะแจ้งเตือนว่า เชื่อมต่อแล้วจ้า~
      </p>
    </div>
  );
};

export default InstructionTelegram;